import React from "react";
import { Link } from "react-router-dom";
import TeroumaLogo from "../components/ui/TeroumaLogo";

// Mentions légales (article 6 de la loi n° 2004-575 du 21 juin 2004, LCEN).
// Éditeur : L.I.A (SASU), d'après le registre public (recherche-entreprises,
// vérifié le 29/09/2026). Hébergeurs : adresses relevées sur leurs pages
// officielles le 29/09/2026.
// ⚠️ Le téléphone est affiché PROVISOIREMENT pour la vérification d'entreprise
// Meta (WhatsApp) : à retirer dès que Meta a validé (demande d'Avi).

const EDITEUR = [
  ["Dénomination", "L.I.A"],
  ["Forme", "Société par actions simplifiée à associé unique (SASU), au capital de 1 000 €"],
  ["Immatriculation", "RCS Créteil 929 222 545 — SIRET du siège 929 222 545 00022"],
  ["Siège social", "4 Place du Général Leclerc, 94130 Nogent-sur-Marne, France"],
  ["Directeur de la publication", "Jérémy Sebag, président"],
  ["Contact", "contact@terouma.fr"],
  ["Téléphone", "+33 6 63 72 19 50"],
];

const HEBERGEURS = [
  {
    role: "Site terouma.fr",
    nom: "Vercel Inc.",
    adresse: "440 N Barranca Avenue #4133, Covina, CA 91723, États-Unis",
  },
  {
    role: "Service applicatif api.terouma.fr et données",
    nom: "OVH SAS, au capital de 50 000 000 €, RCS Lille Métropole 424 761 419",
    adresse: "2 rue Kellermann, 59100 Roubaix, France",
  },
];

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-ui font-semibold text-xl" style={{ color: "var(--trm-ink)" }}>{title}</h2>
      <div className="mt-3 text-[15px] leading-relaxed" style={{ color: "var(--trm-muted)" }}>{children}</div>
    </section>
  );
}

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen" style={{ background: "var(--trm-surface)" }}>
      <header className="px-5 sm:px-8 py-5 border-b" style={{ borderColor: "var(--trm-border)" }}>
        <Link to="/" aria-label="Accueil Terouma" className="inline-flex">
          <TeroumaLogo size={32} />
        </Link>
      </header>

      <main className="px-5 sm:px-8 py-10 max-w-3xl mx-auto">
        <p className="text-[11px] uppercase tracking-[0.2em]" style={{ color: "var(--trm-gold)" }}>Informations légales</p>
        <h1 className="font-ui font-semibold text-3xl tracking-tight mt-1.5" style={{ color: "var(--trm-ink)" }}>
          Mentions légales
        </h1>
        <p className="mt-4 text-[15px] leading-relaxed" style={{ color: "var(--trm-muted)" }}>
          Terouma (terouma.fr) est un service de gestion des dons pour les synagogues et associations,
          édité par la société L.I.A.
        </p>

        <Section title="Éditeur">
          <dl className="grid grid-cols-1 sm:grid-cols-[220px_1fr] gap-x-6 gap-y-2">
            {EDITEUR.map(([k, v]) => (
              <React.Fragment key={k}>
                <dt className="font-medium" style={{ color: "var(--trm-ink)" }}>{k}</dt>
                <dd className="break-words">{v}</dd>
              </React.Fragment>
            ))}
          </dl>
        </Section>

        <Section title="Hébergement">
          <ul className="space-y-3">
            {HEBERGEURS.map((h) => (
              <li key={h.role}>
                <span className="font-medium" style={{ color: "var(--trm-ink)" }}>{h.role} : </span>
                {h.nom}, {h.adresse}.
              </li>
            ))}
          </ul>
        </Section>

        <Section title="Paiements et reçus fiscaux">
          Les paiements en ligne sont traités par Stripe. Les fonds sont versés directement sur le compte
          de l'association bénéficiaire. Les reçus fiscaux sont émis par l'association, sous sa seule
          responsabilité.
        </Section>

        <Section title="Données personnelles">
          Pour toute question ou demande concernant vos données personnelles, écrivez à contact@terouma.fr.
        </Section>

        <p className="mt-12 text-sm">
          <Link to="/" className="underline" style={{ color: "var(--trm-ink)" }}>Retour à l'accueil</Link>
        </p>
      </main>
    </div>
  );
}
